import { AxiosResponse, AxiosRequestConfig } from 'axios'
import * as qs from 'query-string'

import { scansApi } from '.'

import { Scan } from '../interfaces/Scan.interface'
import { ScansByEmployee } from '../interfaces/ScansByEmployee.interface'

export type FetchScansQuery = {
  vin?: string
  toDate?: string
  fromDate: string

  location?: number
  position?: number[]
}

export const getScansList = (filterParams: FetchScansQuery) => {
  const axiosConfig: AxiosRequestConfig = {
    params: filterParams,
    paramsSerializer: p => qs.stringify(p)
  }

  return scansApi.get<Scan[]>('/scan', axiosConfig)
    .then((response: AxiosResponse) => response.data)
}

export const getScansListByEmployee = (filterParams: FetchScansQuery) => {
  const axiosConfig: AxiosRequestConfig = {
    params: filterParams,
    paramsSerializer: p => qs.stringify(p)
  }

  return scansApi.get<ScansByEmployee[]>('/scan/employee', axiosConfig)
    .then((response: AxiosResponse) => response.data)
}



// WEBPACK FOOTER //
// ./src/lib/api/scans.ts